// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6P2cl","fullView":"styles_fullView__3xhad"};